import type { UserData, UUID } from '@cobliteam/common-types';
import useAuthStore, { type AuthState } from './useAuthStore';

/**
 * Projeção da fatia `userData` do `useAuthStore` unificado. Shim durante a migração; novos
 * consumidores devem importar `useAuthStore` diretamente.
 */
export interface UserDataState {
  userId: UUID | null;
  userData: UserData | null;
  setUserData: (userId: UUID, userData: UserData) => void;
  clearUserData: () => void;
}

const projectUserDataState = (s: AuthState): UserDataState => ({
  userId: s.userId,
  userData: s.userData,
  setUserData: s.setUserData,
  clearUserData: s.clearUserData,
});

function useUserDataStore<T>(selector: (state: UserDataState) => T): T {
  return useAuthStore((s) => selector(projectUserDataState(s)));
}

useUserDataStore.getState = (): UserDataState => projectUserDataState(useAuthStore.getState());

export default useUserDataStore;
